import * as React from 'react';
import { useState } from 'react';
import { R } from '@/features/programs/resources/ProgramsResources.resx';
import {
    BoxstarBlueIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    EditIcon,
} from '@/components/Icons';
import { format as formatString } from '@/Resources.resx';
import { EditDeleteWeightLogModal } from './EditDeleteWeightLogModal';
import { WeightLogCardType } from '@/features/programs/widgets/sundvaegt/model/types';

interface WeightLogCardProps {
    card: WeightLogCardType;
    minDate: Date;
}

export const WeightLogCard: React.FC<WeightLogCardProps> = ({
    card,
    minDate,
}) => {
    const [expanded, setExpanded] = useState(false);

    const [showEditDeleteWeightLogModal, setShowEditDeleteWeightLogModal] =
        useState<boolean>(false);

    const openEditDeleteWeightLogModal = (): void => {
        setShowEditDeleteWeightLogModal(true);
    };
    const closeEditDeleteWeightLogModal = (): void => {
        setShowEditDeleteWeightLogModal(false);
    };

    return (
        <div className="ns:rounded-2xl flex w-full flex-col rounded-lg border-[1px] border-gray-300 bg-white p-4">
            {/* Header */}
            <div
                className="flex cursor-pointer items-center justify-between"
                onClick={() => setExpanded(!expanded)}
            >
                <div className="flex items-center gap-3">
                    <BoxstarBlueIcon className="h-10 w-10" />
                    <div>
                        <div className="text-lg font-semibold">
                            {card?.formattedWeight}
                        </div>
                        <div className="text-sm text-gray-500">
                            {card?.formattedDate}
                        </div>
                    </div>
                </div>
                {expanded ? (
                    <ChevronUpIcon className="h-6 w-6 text-gray-500" />
                ) : (
                    <ChevronDownIcon className="h-6 w-6 text-gray-500" />
                )}
            </div>

            {/* Expanded content */}
            {expanded && (
                <div className="mt-4 space-y-3">
                    {!card?.isFirstLog && card?.formattedLastLoss && (
                        <div>
                            <div className="font-semibold">
                                {R.SundvaegtWeightLogCardLatestWeightLossLabel}
                            </div>
                            <div>{card?.formattedLastLoss}</div>
                        </div>
                    )}

                    {card?.formattedTotalLoss &&
                        card.formattedTotalWeightLossGoal && (
                            <div className={card.isFirstLog ? 'mt-6' : ''}>
                                <div className="font-semibold">
                                    {
                                        R.SundvaegtWeightLogCardOverallWeightLossLabel
                                    }
                                </div>
                                <div>
                                    {formatString(
                                        R.SundvaegtWeightLogCardOverallWeightLossStatus,
                                        card?.formattedTotalLoss,
                                        card?.formattedTotalWeightLossGoal,
                                    ).toString()}
                                </div>
                            </div>
                        )}
                    <div
                        className="mt-6 flex cursor-pointer flex-row text-[18px] leading-[1.8rem] font-bold"
                        onClick={() => {
                            openEditDeleteWeightLogModal();
                        }}
                    >
                        <EditIcon className="cursor-pointer" />
                        <span className="cursor-pointer px-2">
                            {R.SundvaegtWeightEditWeightLogLabel}
                        </span>
                    </div>
                </div>
            )}
            {showEditDeleteWeightLogModal && (
                <EditDeleteWeightLogModal
                    onClose={closeEditDeleteWeightLogModal}
                    minDate={minDate}
                    weightLog={{
                        id: card.Id,
                        weightKg: card.WeightKg,
                        formattedDate: card.formattedDate,
                        date: card.Date,
                        isFirstLog: card.isFirstLog,
                    }}
                />
            )}
        </div>
    );
};
